// permissions/getRoutesByPermission.ts

import { roleRoutesMap } from './routesMap';

export const getRoutesByPermission = async (
  permissions: Record<string, boolean>,
  modelId?: number
): Promise<string[]> => {
  if (!permissions || Object.keys(permissions).length === 0) {
    return roleRoutesMap.guest;
  }

  if (permissions.admin === true) {
    return roleRoutesMap.admin;
  }

  if (modelId === 200) {
    return roleRoutesMap.agent;
  }

  return roleRoutesMap.user;
};
